import { render, staticRenderFns } from "./ykc-search.vue?vue&type=template&id=189e7086&"
import script from "./ykc-search.vue?vue&type=script&lang=js&"
export * from "./ykc-search.vue?vue&type=script&lang=js&"
import style0 from "./ykc-search.vue?vue&type=style&index=0&id=189e7086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports